import { useCallback } from "react";
import { Grid, Divider, Typography } from "@material-ui/core";
import { Box, Button, List, ListItem } from "~/components/UI";
import Highlighter from "react-highlight-words";
import history from "~/packages/history";
import ROUTES from "~/constants/routes";
import { useTranslation } from "react-i18next";

interface MerchantsResultProps {
  data?: Api.SearchResult<MerchantsApi.MerchantSearchResult>;
  searchQuery: string;
}

const Merchant = ({
  merchant,
  searchQuery,
}: {
  searchQuery: string;
  merchant: MerchantsApi.MerchantSearchResult;
}) => {
  const openGroup = useCallback(() => {
    history.push(`${ROUTES.MERCHANTS}?id=${merchant.id}`);
  }, [merchant.id]);

  return (
    <ListItem button onClick={openGroup}>
      <Typography variant="body2" color="textSecondary">
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={merchant.merchantName}
        />{" "}
        [
        <Typography variant="body2" component="span" color="primary">
          ID
        </Typography>
        :{" "}
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={merchant.id}
        />
        ]
      </Typography>
      <Divider />
    </ListItem>
  );
};

/**
 * @memberof GlobalSearch
 * @component
 * @desc Render of search results for the Merchants catalog.
 * @property {string} searchQuery - the text we are looking for
 * @property {Api.SearchResult<Api.MerchantSearchResult>} data - api response
 */

const Merchants = ({ data, searchQuery }: MerchantsResultProps) => {
  const { t } = useTranslation();

  const onShowAll = useCallback(() => {
    setTimeout(() => {
      history.push(`${ROUTES.MERCHANTS}?search=${searchQuery}`);
    }, 0);
  }, [searchQuery]);

  if (data && data.count) {
    return (
      <Box mb={4}>
        <Box py={4}>
          <Grid container alignItems="center">
            <Grid item sm>
              <Typography variant="subtitle1">
                {t("title.catalogMerchants")} ({data.count})
              </Typography>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={onShowAll}>
                {t("button.showAll")}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <List>
          {data.data.map((u, index) => (
            <Merchant key={index} searchQuery={searchQuery} merchant={u} />
          ))}
        </List>
      </Box>
    );
  } else {
    return null;
  }
};

export default Merchants;
